import { render, staticRenderFns } from "./BooleanWidget.vue?vue&type=template&id=4036d111&lang=pug&"
import script from "./BooleanWidget.vue?vue&type=script&lang=js&"
export * from "./BooleanWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports